import React from "react";
import styles from "./Actions.module.css";
import {EditButton} from "../editButton/EditButton";
import {DeleteButton} from "../deleteButton/DeleteButton";
import {useAppDispatch} from "../../../app/hooks";
import {openPopupModal, PopupModalName} from "../popupModalProvider/popupModalSlice";
import {FormName, openForm} from "../formProvider/formSlice";

interface ActionsProps {
    index: number
    publicId: string
    editFormName: FormName
    deleteModalName?: PopupModalName,
    canBeDeleted?: boolean
    formProps?: Record<string, any>
    entityName?: string
}

export const Actions: React.FC<ActionsProps> = ({
                                                    index,
                                                    publicId,
                                                    editFormName,
                                                    deleteModalName,
                                                    canBeDeleted = true,
                                                    formProps,
                                                    entityName
                                                }) => {

    const dispatch = useAppDispatch()

    const handleEditClick = () => {
        dispatch(openForm({name: editFormName, formProps: formProps || {publicId}}))
    }

    const handleDeleteClick = () => {
        if (deleteModalName) {
            dispatch(openPopupModal({name: deleteModalName, popupModalProps: {publicId, entityName}}))
        }
    }

    return <div key={index} className={styles.wrapper}>
        <EditButton disabled={false} handleClick={handleEditClick}/>
        <DeleteButton disabled={!canBeDeleted} handleClick={handleDeleteClick}/>
    </div>
}
